import React from 'react'
import RemoveModal from 'src/components/theme/Models/RemoveModal'
import { StaffingAgencyPocsDocument } from 'src/gql/graphql'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import { UseToggleStateValueReturn } from 'src/hooks/useToggleStateValue'
import { useMutateDeleteStaffingAgencyPocById } from 'src/queries'

interface AddModalProps {
  delete: UseToggleStateValueReturn<string>
  staffingAgency: string
}

const AddModal: React.FC<AddModalProps> = (props) => {
  const { staffingAgency } = props
  const { value: id, hasState: isOpen, toggle } = props.delete

  const mutateDelete = useMutateDeleteStaffingAgencyPocById()
  const invalidate = useInvalidateQueryByDocument(StaffingAgencyPocsDocument)
  const handleDelete = (): void => {
    mutateDelete.mutate({ id }, {
      onSuccess: () => {
        void invalidate({ filter: { staffingAgency } })
        toggle()
      }
    })
  }
  return (
    <RemoveModal
      isOpen={isOpen}
      onRemove={handleDelete}
      onCancel={toggle}
      toggle={toggle}
      error={{
        error: 'There was an issue deleting the poc.',
        show: mutateDelete.isError
      }}
    >
      Are you sure you want to delete this poc?
    </RemoveModal>
  )
}

export default AddModal
